import NodeIcon from "@atlaskit/icon/core/node";
import OfficeBuildingIcon from "@atlaskit/icon/core/office-building";
import {token} from "@atlaskit/tokens";
import {JourneyProgressCardStatusBadge} from "./JourneyProgressCardStatusBadge";
import type {JourneyProgressStatus} from "./types";

export function JourneyProgressCardHeader({
    title,
    status,
    ouName,
}: {
    title: string;
    status: JourneyProgressStatus;
    ouName?: string | null;
}) {
    const hasOu = typeof ouName === "string" && ouName.trim() !== "";

    return (
        <div className="flex w-full min-w-0 flex-col items-start gap-y-ds-space-050 @min-[480px]:flex-row @min-[480px]:items-center @min-[480px]:justify-between @min-[480px]:gap-x-ds-space-100">
            <div className="flex min-w-0 max-w-full items-center gap-x-ds-space-075">
                <span
                    className="min-w-0 truncate"
                    style={{
                        overflow: "hidden",
                        color: token("color.text"),
                        textOverflow: "ellipsis",
                        fontFamily: "Inter",
                        fontSize: "var(--Font-Size-Heading-S, 16px)",
                        fontStyle: "normal",
                        fontWeight: "var(--Font-Weight-Heading, 653)",
                        lineHeight: "var(--Line-Height-Heading-S, 20px)",
                    }}
                >
                    {title}
                </span>
                <span
                    className="inline-flex shrink-0 items-center"
                    style={{color: token("color.icon.subtle")}}
                >
                    <NodeIcon
                        label=""
                        size="small"
                    />
                </span>
                <JourneyProgressCardStatusBadge status={status} />
            </div>
            {hasOu === true ? (
                <div className="flex min-w-0 max-w-full items-center gap-x-ds-space-050">
                    <span
                        className="hidden shrink-0 items-center justify-center @min-[480px]:inline-flex"
                        style={{
                            color: token("color.icon.subtle"),
                            width: 16,
                            height: 16,
                        }}
                    >
                        <OfficeBuildingIcon
                            label=""
                            size="medium"
                        />
                    </span>
                    <span
                        className="min-w-0 truncate"
                        style={{
                            overflow: "hidden",
                            color: token("color.text"),
                            fontFeatureSettings: "'liga' off, 'calt' off",
                            textOverflow: "ellipsis",
                            fontFamily: "Inter",
                            fontSize: "var(--Font-Size-Body-M, 14px)",
                            fontStyle: "normal",
                            fontWeight: "var(--Font-Weight-Body-Bold, 653)",
                            lineHeight: "var(--Line-Height-Body-M, 20px)",
                        }}
                    >
                        {ouName}
                    </span>
                </div>
            ) : null}
        </div>
    );
}
